import { InformationCircleIcon} from '@heroicons/react/24/outline';

interface AdminInfoBannerProps {
    title: string;
    description: string;
    className?: string;
}

export default function AdminInfoBanner({ title, description, className = '' }: AdminInfoBannerProps) {
    return (
        <div className={`bg-blue-600/10 border border-blue-400/20 rounded-xl p-4 mb-6 ${className}`}>
            <div className="flex items-start gap-3">
                <InformationCircleIcon className="h-6 w-6 text-blue-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                    <h3 className="text-blue-200 font-semibold mb-2">
                        {title}
                    </h3>
                    <p className="text-blue-100 text-sm mb-3">
                        {description}
                    </p>

                </div>
            </div>
        </div>
    );
}
